module.exports = __webpack_public_path__ + "61822620fbdca0ced26f969dce5b422f.svg";